let cachedResult = null;

export const isIE11 = () => {
  if (cachedResult !== null) {
    return cachedResult;
  }
  if (typeof window === 'undefined') {
    cachedResult = false;
    return cachedResult;
  }
  cachedResult = (navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0);
  return cachedResult;
};



// WEBPACK FOOTER //
// ./helpers/ie.helper.js